export default __webpack_public_path__ + "static/media/PPI-patio-006.20ab9c0a.jpg";